<template>
 <b-modal :active.sync="isComponentModalActive"
             has-modal-card full-screen >

        <div class="modal-card" >
            <section class="modal-card-body ml-5 mr-5"  >
                <b-loading  :active.sync="isFullScreenLoading" />

                <b-field grouped >

                    <b-field label="#" class="mr-5">
                      <template #label>
                        <span class="has-text-white">#</span>
                      </template>
                      <h1 class="has-text-grey-dark is-size-4">Web Log1 </h1>
                    </b-field>



                    <b-field label="Search">
                        <!-- <b-datepicker v-model="dateWebLog1Model"
                                      placeholder="Click to select..."
                                      icon="calendar-today">
                        </b-datepicker> -->

                        <b-datepicker
                            type="month"
                             v-model="dateWebLog1Model"
                            placeholder="Click to select..."
                            icon="calendar-today"
                            trap-focus>
                        </b-datepicker>
                    </b-field>
                    <b-field label="Search">
                        <b-button type="is-success" icon-left="magnify"  outlined @click="searchWebLog1"    ref="btnSearch"  ></b-button>
                    </b-field>


                </b-field>

              {{progressValue}}
               <!--  -->
               <!-- {{dataWeblog1}} -->
               <!-- {{uniqUser}} -->

               <!-- {{uniqIP}} -->
<!--              <div class="container" v-if="dataWeblog1.length>0">-->
<!--                 <apexchart type="donut" -->
<!--                                           width="750" -->
<!--                                           :options="chartOptionsDonut" -->
<!--                                           :series="seriesDonut">-->
<!--                                </apexchart>-->
<!--              </div>-->
                 <b-tabs v-model="activeTab">
                        <b-tab-item label="User Logs">
                               <input class="input" type="text" v-model="filterWord" 
                                       placeholder="Filter for User " 
                                    >  
                               <b-table
                                        :data="isEmpty ? [] : dataWebLog1Filter"
                                        bordered
                                        striped
                                        narrowed
                                        hoverable
                                        focusable
                                        mobile-cards
                                        paginated
                                        :per-page="perPage"
                                        :current-page.sync="currentPage"
                                        >


                                        <b-table-column  label="User" v-slot="props">
                                           <text-highlight :queries="queries">  {{ props.row.user }} </text-highlight>
                                        </b-table-column>

                                        <b-table-column  label="Date Time" v-slot="props">

                                                <b-taglist attached>
                                                    <b-tag size="is-medium">
                                                        {{ getISO8601ToYearMonthDate(props.row.datatime_rec).date }}
                                                        {{ getISO8601ToYearMonthDate(props.row.datatime_rec).month }}
                                                        {{ getISO8601ToYearMonthDate(props.row.datatime_rec).year }}
                                                    </b-tag>
                                                    <b-tag  size="is-medium">
                                                        {{ getISO8601ToYearMonthDate(props.row.datatime_rec).hour }}:
                                                        {{ getISO8601ToYearMonthDate(props.row.datatime_rec).minute }}
                                                    </b-tag>
                                                </b-taglist>


                                            

                                            
                                        </b-table-column>


                                        <b-table-column  label="Action" v-slot="props">
                                            {{ props.row.action }}
                                        </b-table-column>

                                        <b-table-column  label="Detail" v-slot="props">
                                            {{ props.row.detail }}
                                        </b-table-column>


                                        <b-table-column  label="IP" v-slot="props">
                                            {{ props.row.ip }}
                                        </b-table-column>

                                        <b-table-column  label="Kind of IP" v-slot="props">
                                            {{ props.row.type_ip }}
                                        </b-table-column>



                                        <template slot="empty">
                                        <section class="section">
                                            <div class="content has-text-grey has-text-centered">
                                                <p>
                                                    <b-icon
                                                            icon="emoticon-sad"
                                                            size="is-large">
                                                    </b-icon>
                                                </p>
                                                <p>Nothing here.</p>
                                            </div>
                                        </section>
                                    </template>
                                </b-table>
                        </b-tab-item>

                        <b-tab-item label="User summarize">
                             <b-table
                                        :data="isEmpty ? [] : uniqUser"
                                        bordered
                                        striped
                                        narrowed
                                        hoverable
                                        focusable
                                        mobile-cards
                                        class="container"
                                        >

                                        <b-table-column  label="User" v-slot="props">
                                            {{ props.row.user }}
                                        </b-table-column>



                                        <b-table-column  label="Actions Count" v-slot="props">
                                            {{ props.row.count }}
                                        </b-table-column>


                               <template slot="empty">
                                        <section class="section">
                                            <div class="content has-text-grey has-text-centered">
                                                <p>
                                                    <b-icon
                                                            icon="emoticon-sad"
                                                            size="is-large">
                                                    </b-icon>
                                                </p>
                                                <p>Nothing here.</p>
                                            </div>
                                        </section>
                                    </template>
                                </b-table>          
                        </b-tab-item>
                 </b-tabs>        




             


            </section>
            <footer class="modal-card-foot">
                <b-button size="is-medium" type="is-danger"
                          icon-left="close" @click="close">
                    Close
                </b-button>
            </footer>
        </div>

    </b-modal>
</template>

<script>
import {mapActions, mapState , mapMutations } from "vuex";
import getISO8601ToYearMonthDate from '../../mixins/methods/getISO8601ToYearMonthDate'
import _ from 'lodash'

export default {
    name : "WebLog1",
    mixins:[getISO8601ToYearMonthDate,],
    mounted(){
        if(this.dataWeblog1.length>0){
          this.makeDataInjectToChart()  
        }
        
    },
    computed:{
          ...mapState({
            dateWeblog1 : state => state.web_log1.dateWeblog1 ,
            dataWeblog1 : state => state.web_log1.dataWeblog1 ,
            countTotal : state => state.web_log1.countTotal ,
            first : state => state.web_log1.first ,
            skip : state => state.web_log1.skip ,
          }),
         
         dateWebLog1Model :{
                get: function () {
                    return this.dateWeblog1
                },
                set: function (newValue) {
                    this.setDateWeblog1(newValue)
                }
         },

         dataWebLog1Filter(){
            return this.dataWebLog1Compute.filter(dat=>{
                                    return dat.user.indexOf(this.filterWord) > -1  
                               }                     
                            )
         }, 
         dataWebLog1Compute:function () {
               return this.dataWeblog1.map((dat) =>{
                   // console.log(typeof dat.detail
                       if(typeof dat.detail === "object"){
                           const tmp =  dat.detail.type == 1 ?
                               `ชนิด 1 คำค้น ${dat.detail.dat_type1.idopd}  ${dat.detail.dat_type1.owner}   ${dat.detail.dat_type1.ownersurname}   ${dat.detail.dat_type1.opdname} `:
                               `ชนิด 2 คำค้น ${dat.detail.dat_type2.homeaddress} `
                           dat.detail = tmp
                       }
                     return dat
                    })
         } ,

         uniqUser(){
            const tmpUser =  _.uniqBy(this.dataWeblog1, 'user')
                              .map(dat=> dat.user)
            let  userWithCount = []                  
            for(var i =0 ; i<=tmpUser.length-1;i++ ){
                    const eachUserArr = this.dataWeblog1.filter(dat=>dat.user == tmpUser[i])
                    userWithCount.push({
                        "user" : tmpUser[i],
                        "count" : eachUserArr.length
                    })
                    
            }                 

            
            return  _.orderBy(userWithCount, ['count',])             
         },


         uniqIP(){
            const tmpType_IP=  _.uniqBy(this.dataWeblog1, 'type_ip_code')
                                     .map(dat=> dat.type_ip)
            let  IPWithCount = []                  
            for(var i =0 ; i<=tmpType_IP.length-1;i++ ){
                    const eachIPArr = this.dataWeblog1.filter(dat=>dat.type_ip == tmpType_IP[i])
                    IPWithCount.push({
                        "ip" : tmpType_IP[i],
                        "count" : eachIPArr.length
                    })
                    
            }                 
            return _.orderBy(IPWithCount, ['ip',])                   
         },

         queries(){
              return this.filterWord.split(" ");
         },





    },
    methods:{
           ...mapActions({
            fetchDataWeblog1 : 'web_log1/fetchDataWeblog1',
            fetchDataWeblog1Count : 'web_log1/fetchDataWeblog1Count',
        }),
           ...mapMutations({
            setDateWeblog1 : 'web_log1/setDateWeblog1',
            setDataWeblog1: 'web_log1/setDataWeblog1',
            setFirst: 'web_log1/setFirst',
            setSkip: 'web_log1/setSkip',
          }),
        close(){
            this.$emit('closeModalWebLog1')
        },
      async searchWebLog1() {
        try {
          this.isFullScreenLoading = true;
          this.progressValue = 0;

          // reset
          this.setDataWeblog1([]);
          this.setSkip(0);

          // 1) count
          await this.fetchDataWeblog1Count();
          const total = this.countTotal;

          if (total <= 0) {
            this.progressValue = 100;
            this.isFullScreenLoading = false;
            return;
          }




          // 2) loop
          while (this.dataWeblog1.length < total) {
            // fetch ตาม skip ปัจจุบัน
            const rows = await this.fetchDataWeblog1();
            if (rows.length === 0) break;
            // concat เพื่อเพิ่ม length
            this.setDataWeblog1(this.dataWeblog1.concat(rows));
            // update skip AFTER fetch
            this.setSkip(this.skip + this.first);
            // progress
            const current = this.dataWeblog1.length;
            this.progressValue = Math.round(current * 100 / total);
          }

          this.progressValue = 100;
          // this.makeDataInjectToChart();

        } finally {
          this.isFullScreenLoading = false;
        }
      },



      // async searchWebLog1() {
      //   try {
      //     this.isFullScreenLoading = true;
      //     this.progressValue = 0;
      //
      //     // เคลียร์ข้อมูลเก่า + reset skip
      //     this.setDataWeblog1([]);
      //     this.setSkip(0);
      //
      //     // 1) เรียก count ก่อน
      //     await this.fetchDataWeblog1Count();
      //     const total = this.countTotal;
      //
      //     if (!total || total <= 0) {
      //       this.progressValue = 100;
      //       return;
      //     }
      //
      //     // 2) วนเรียก chunk เรื่อย ๆ จนกว่าจะครบ
      //     while (this.dataWeblog1.length < total) {
      //       //
      //
      //       const rows = await this.fetchDataWeblog1();
      //       this.setSkip(this.skip + this.first);
      //       // console.log(rows);
      //       // this.setDataWeblog1(this.dataWeblog1.concat(rows));
      //
      //       // เผื่อ safety – ถ้า BE คืน 0 row มา ให้ break กัน loop infinite
      //       if (rows.length === 0) {
      //         break;
      //       }
      //
      //       // update progress (%)
      //       const current = this.dataWeblog1.length;
      //       this.progressValue = Math.round(current * 100 / total);
      //     }
      //
      //     // ให้ progress = 100 ชัวร์ ๆ
      //     this.progressValue = 100;
      //
      //   } catch (err) {
      //     console.error("searchWebLog1 error:", err);
      //     this.$buefy.toast.open({
      //       message: 'เกิดข้อผิดพลาดในการโหลด WebLog1',
      //       type: 'is-danger',
      //     });
      //   } finally {
      //     this.isFullScreenLoading = false;
      //   }
      // },
       // searchWebLog1(){
          // this.fetchDataWeblog1Count()
          //     .then(()=>{
          //      console.log(this.countTotal);
          // })

            // this.isFullScreenLoading = true
            // this.fetchDataWeblog1()
            //     .then(()=>{
            //       this.currentPage = 1;
            //       this.makeDataInjectToChart();
            //       this.isFullScreenLoading = false;
            //     })
            //     .catch((err)=>{
            //       const backendMsg = err.response?.data?.msg ?? err.message;
            //       this.$buefy.dialog.alert({
            //         title: 'Error',
            //         message: backendMsg,
            //         type: 'is-danger',
            //         hasIcon: true,
            //         icon: 'alert-circle',
            //         ariaRole: 'alertdialog',
            //         ariaModal: true
            //       })
            //       this.isFullScreenLoading = false;
            //     })
    //    },
        makeDataInjectToChart(){
                    this.seriesDonut =  this.uniqIP.map(dat=>dat.count)             
                     

                    this.chartOptionsDonut = {...this.chartOptionsDonut, ...{
                                            // xaxis: {
                                            //      categories :  this.dataCheckin.group.map(dat=>dat.species)
                                            // }
                                            labels: this.uniqIP.map(dat=>{
                                                return  `${dat.ip}  ${dat.count} ครั้ง`
                                                 
                                            } )  
                                         }
                                        }

            },
    },
    data(){
        return {
            isComponentModalActive : false,
            isFullScreenLoading: false,

            date_selected : null,
            dataWebLog : [],
            isEmpty : false,
            perPage : 50 ,
            currentPage : 1,

            activeTab : 0,
            progressValue : 0,



            seriesDonut:[],// [44, 55, 13, 43, 22],
            chartOptionsDonut: {
                chart: {
                width: '750',
                type: 'donut',
                },
                tooltip: {
                    enabled: false,
                       y: {
                            formatter: undefined,
                            title: {
                                formatter: (seriesName) => seriesName,
                            },
                        },
                },
                labels: [],// ['Team A', 'Team B', 'Team C', 'Team D', 'Team E'],
                responsive: [{
                breakpoint: 480,
                options: {
                    chart: {
                    width: 200
                    },
                    legend: {
                    position: 'bottom'
                    }
                  }
                 }]
              },


              filterWord : "",



        }
    }
}
</script>